module.exports = __webpack_public_path__ + "static/media/skopei.a1557658.svg";